'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

import ProjectChronologyController from './controller/project-chronology';

export default angular.module('investmentProject.reports.project-chronology', [])
                      .controller('ProjectChronologyController', ProjectChronologyController)
    .name;
